import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';
import { EmojiEvents, ChevronRight } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { TOURNAMENT_ACCENT } from './tournamentFormat';

const useStyles = makeStyles(() => ({
  link: {
    display: 'inline-grid',
    gridTemplateColumns: 'auto minmax(0, auto) auto',
    gridColumnGap: 6,
    alignItems: 'center',
    maxWidth: 320,
    height: 30,
    padding: '0 8px 0 10px',
    borderRadius: 15,
    cursor: 'pointer',
    fontSize: '0.8rem',
    fontWeight: 800,
    color: '#ffe082',
    background: 'rgba(255, 179, 0, 0.12)',
    border: '1px solid rgba(255, 179, 0, 0.45)',
    verticalAlign: 'middle',
    transition: 'background 0.12s, border-color 0.12s',
    '&:hover': {
      background: 'rgba(255, 179, 0, 0.2)',
      borderColor: TOURNAMENT_ACCENT,
    },
  },
  name: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

/**
 * A link back to the tournament a game, duel or PvE run was played in (shown only when there is one). Shared by the
 * app and the website.
 */
export const TournamentLink: React.FC<{tournament?: {_id?: any, name?: string | null} | null, style?: React.CSSProperties}> = ({tournament, style}) => {
  const classes = useStyles();
  const history = useHistory();
  if(!tournament || !tournament._id)
    return null;
  return (
    <Tooltip title="Open the tournament">
      <span role="button" className={classes.link} style={style} onClick={() => history.push(`/tournaments/${tournament._id}`)}>
        <EmojiEvents style={{fontSize: 16, color: TOURNAMENT_ACCENT}} />
        <span className={classes.name}>{tournament.name || 'Tournament'}</span>
        <ChevronRight style={{fontSize: 16, opacity: 0.7}} />
      </span>
    </Tooltip>
  );
}
